import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import reducers from '../modules'
import { loadInitialHtmlStartupData } from '../modules/app/app.actions'

const isDevelopment = process.env.NODE_ENV === 'development'

export default htmlStartupData => {
  const composeEnhancers =
    isDevelopment && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose

  const middleware = [thunk]

  const store = createStore(
    combineReducers(reducers),
    composeEnhancers(applyMiddleware(...middleware))
  )

  store.dispatch(loadInitialHtmlStartupData(htmlStartupData))

  if (isDevelopment) {
    window.store = store
  }

  return store
}
